'use client';
import { useEffect, useState } from 'react';
import Layout from '../Components/Layout/Layout';
import CartItems from './components/CartItems';
import OrderSummary from './components/OrderSummary';
import CheckoutForm from './components/CheckoutForm';
import styles from './cart.module.css';
import gsap from 'gsap';
import CartTicket from '../Components/Navbar/CartTicket';

export default function Cart() {
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      name: 'ZINC Premium',
      variant: '2 month supply',
      quantity: 2,
      price: 30.00,
      image: 'https://longevity20155.sirv.com/zinc/1.webp',
    },
    {
      id: 2,
      name: 'MINCI Advanced',
      variant: '1x',
      quantity: 1,
      price: 35.00,
      image: 'https://longevity20155.sirv.com/minci/1.webp',
    },
    {
      id: 3,
      name: 'TESTO Boost',
      variant: '2x',
      quantity: 1,
      price: 40.00,
      image: 'https://longevity20155.sirv.com/testo/1.webp',
    },
  ]);

  const updateQuantity = (id, newQuantity) => {
    if (newQuantity < 1) return;
    setCartItems(items =>
      items.map(item =>
        item.id === id ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  const removeItem = (id) => {
    setCartItems(items => items.filter(item => item.id !== id));
  };
useEffect(()=>{
 const ctx = gsap.context(() => {
      
        const navbar = document.querySelector('#navbar');
        if (navbar) {
          gsap.timeline().fromTo('#navbar',
            { autoAlpha: 0,y:"-100%" },
            { autoAlpha: 1, y:0,ease: 'sin.in',duration:"1.5" },"a"
      
          ).fromTo("."+styles.leftSection,{y:"-100%",autoAlpha:0},{y:0,autoAlpha:1,duration:"1"},"a").fromTo("."+styles.rightSection,{y:"100%",autoAlpha:0},{y:0,autoAlpha:1,duration:"1"},"a");
        }})
        return ()=>ctx.revert()

},[])
  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const shipping = 5.00;
  const tax = subtotal * 0.1;
  const total = subtotal + shipping + tax;

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.leftSection}>
            <h1 className={styles.title}>Shopping Cart</h1>
            <p className={styles.itemCount}>{cartItems.length} Items</p>
            
            <CartItems 
              items={cartItems}
              onUpdateQuantity={updateQuantity}
              onRemove={removeItem}
            />
          </div>

          <div className={styles.rightSection}>
            <OrderSummary
              subtotal={subtotal}
              shipping={shipping}
              tax={tax}
              total={total}
            />
            <CheckoutForm />
          </div>
        </div>
      </div>
      <CartTicket/>
    </Layout>
  );
}
